<div class="maintanence-wrapper">
  <mat-icon>warning_amber</mat-icon>
  <h3 class="maintenance-text">
    {{ languageContent?.title }}
  </h3>
  <p class="text-container">
    {{ languageContent?.description }}
  </p>
  <mat-icon
    class="close-container"
    (click)="onClose()">
    close
  </mat-icon>
</div>
